namespace Matrix.Data {
    export interface TestResultMutingResponse extends Serenity.ServiceResponse {
    }
}
